<header-component></header-component>
<signup-component></signup-component>
<resetPassword *ngIf="resetPassword" [resetPasswordLink]="resetPasswordLink" [emailId]="emailId" (_closePopup)="closeResetPopup()"></resetPassword>
<uvsity-spinner [showSpinner]="showSpinner"></uvsity-spinner>